import fetch from 'isomorphic-fetch';

import config from '../common/config';

export async function get(endpoint) {
  const response = await fetch(`${config.apiUrl()}/${endpoint}`);

  if (response.status >= 400) {
    throw new Error('Bad response from server');
  }

  return response;
}

export async function post(endpoint, body, options = {}) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    ...options
  };

  const response = await fetch(
    `${config.apiUrl()}/${endpoint}`,
    {
      body: JSON.stringify(body),
      ...requestOptions
    }
  );

  if (response.status >= 400) {
    throw new Error('Bad response from server');
  }

  return response;
}



// WEBPACK FOOTER //
// ./src/common/api.js